import type { ReactNode } from 'react';
import type { TenantPublic } from '@/shared/contracts';
import { supportHref } from '@/shared/support';

/** Only the configured public inbox and a subject enter the draft, never page URLs or account data. */
export function SupportLink({
  tenant,
  topic = 'Academy help',
  children = 'Email support',
  className = '',
}: {
  tenant: Pick<TenantPublic, 'name' | 'support_email'>;
  topic?: string;
  children?: ReactNode;
  className?: string;
}) {
  const href = supportHref(tenant, topic);
  if (!href) return null;
  return (
    <a
      href={href}
      className={`inline-flex min-h-11 items-center text-[14px] text-accentText underline underline-offset-4 [overflow-wrap:anywhere] ${className}`}
    >
      {children}
    </a>
  );
}
